import { keyBy } from 'lodash';
import topMoverService from '../../../../core/services/Market/TopMover/TopMoverService';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import ConstTopMover from '../Const';
import Const from './Const';
import currentState from './../../../helpers/CurrentState';
import ConstCommon from './../../../common/Const';
import { handleExport } from '../../../helpers/HandleExport';

export const REDUCER_NAME = 'TOP_FOREIGN_TRADING:OVERVIEW:';
const FETCH_LIST_OVERVIEW_TABLE = `${REDUCER_NAME}FETCH_LIST_OVERVIEW_TABLE`;
const CHANGE_OPTION = `${REDUCER_NAME}CHANGE_OPTION`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const SUBSCRIBE_REALTIME_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK`;
const UPDATE_CHART_IMAGE = `${REDUCER_NAME}UPDATE_CHART_IMAGE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;

export const downloadTopForeignTrading = (
  apiParams,
  fileName = 'export-file-name',
) => dispatch => {
  topMoverService.downloadTopForeignTrading(apiParams).then(response => {
    handleExport(response, fileName);
  });
};

export const cancelFetchListTopForeignTradeTable = () => () => {
  Interval.cancel('TopForeignTrade');
};

export const changeSortState = sortState => {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
};

export const changeOption = option => ({
  type: CHANGE_OPTION,
  payload: option,
});

export const fetchListTopForeignTradeTable = (
  filter = 'All',
  option = 'NetBuyVol',
) => dispatch => {
  Interval.fetch(
    'TopForeignTrade',
    dispatch,
    () => {
      dispatch(setLoading(true));
      return topMoverService.getDataTopForeignTrading({
        ComGroupCode: filter,
        Option: option,
      });
    },
    response => {
      if (response) {
        const listDataTopForeignTrade = response.items || [];

        dispatch({
          type: FETCH_LIST_OVERVIEW_TABLE,
          payload: {
            listDataTopForeignTrade,
            option,
          },
        });
      }
      dispatch(setLoading(false));
    },
    ConstTopMover.topForeignTradeInterval,
    err => dispatch(setLoading(false)),
  );
};

export const setLoading = isLoading => dispatch => {
  dispatch({
    type: SET_LOADING,
    payload: isLoading,
  });
};

export const subscribeRealtimeTickTopForeignTrade = data => ({
  type: SUBSCRIBE_REALTIME_TICK,
  payload: {
    data,
  },
});

export const fetchChartImage = (organCode, theme) => dispatch => {
  topMoverService
    .getTopVolumeChartImage({
      organCode,
      theme,
    })
    .then(({ items }) => {
      dispatch({
        type: UPDATE_CHART_IMAGE,
        payload: {
          organCode,
          image: items ? items[0] : '',
        },
      });
    });
};

const initialState = {
  isLoading: false,
  listDataTopForeignTradeTicker: [],
  listObjectDataTopForeignTradeByTicker: {},
  images: {},
  component: {},
  sortState: {},
};

const reducer = (globalState = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...globalState,
        ...initialState,
        option:
          currentState.get(
            ConstCommon.listComponent.TopForeignTrade,
            'option',
          ) || Const.defaultOption,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_OVERVIEW_TABLE:
      const listObjectDataTopForeignTradeByTicker = keyBy(
        action.payload.listDataTopForeignTrade,
        'organCode',
      );
      const listDataTopForeignTradeTicker = action.payload.listDataTopForeignTrade.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDataTopForeignTradeTicker,
        listObjectDataTopForeignTradeByTicker,
      };

    case SET_LOADING:
      return { ...globalState, isLoading: action.payload };

    case SUBSCRIBE_REALTIME_TICK:
      const listObjectDataTopForeignTradeByTickerNew = {
        ...globalState.listObjectDataTopForeignTradeByTicker,
      };

      action.payload.data.forEach(item => {
        if (listObjectDataTopForeignTradeByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listObjectDataTopForeignTradeByTickerNew[item.organCode],
          };

          if (tickerItem) {
            tickerItem.volume = item.totalMatchVolume;
            tickerItem.price = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
            tickerItem.performance.percentPriceChange1Day =
              item.percentPriceChange;
          }
          listObjectDataTopForeignTradeByTickerNew[item.organCode] = tickerItem;
        }
      });

      return {
        ...globalState,
        listObjectDataTopForeignTradeByTicker: listObjectDataTopForeignTradeByTickerNew,
      };

    case UPDATE_CHART_IMAGE:
      return {
        ...globalState,
        images: {
          ...globalState.images,
          [action.payload.organCode]: action.payload.image,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case CHANGE_OPTION:
      currentState.add(
        ConstCommon.listComponent.TopForeignTrade,
        'option',
        action.payload,
      );
      return {
        ...globalState,
        option: action.payload,
      };
    case CHANGE_SORT_STATE:
      return {
        ...globalState,
        sortState: action.payload,
      };

    default:
      return globalState;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
